import React, { useState, useEffect } from "react";
import { Button, message as antdMessage, Tooltip, Card, Empty } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import "./announcement.scss";
import { useNavigate } from "react-router-dom";
import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";

function Announcement() {
  const [announcements, setAnnouncements] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchAnnouncements();
  }, []);

  const fetchAnnouncements = async () => {
    try {
      const response = await axiosInstance.get(API.announcement.getAll);
      setAnnouncements(response.data || []);
    } catch (error) {
      antdMessage.error("An error occurred while fetching announcements: " + error.message);
    }
  };

  const truncateText = (text, maxLength) =>
    text?.length > maxLength ? text.substring(0, maxLength) + "..." : text;

  const handleViewAnnouncement = (ann) => {
    navigate(`/employeedashboard/emp-announcement-detail/${ann.id}`, {
      state: { announcement: ann },
    });
  };

  return (
    <Card title="Announcements" style={{ height: "100%" }} className="card-professional">
      <div className="row">
        <div className="announcement-list">
          {announcements.length > 0 ? (
            announcements.map((ann) => (
              <div key={ann.id} className="announcement-container">
                <FontAwesomeIcon icon={faInfoCircle} className="frame-icon" />
                <div className="announcement-content">
                  <p className="announcement-text">
                    <Tooltip title={ann.title} trigger="hover">
                      {truncateText(ann.title, 50)}
                    </Tooltip>
                  </p>
                  <p className="message-text">
                    <Tooltip title={ann.message} trigger="hover">
                      {truncateText(ann.message, 45)}
                    </Tooltip>
                  </p>
                </div>
                <Button
                  className="complete-button"
                  type="primary"
                  onClick={() => handleViewAnnouncement(ann)}
                >
                  View Announcement
                </Button>
              </div>
            ))
          ) : (
            <Empty description="No announcement information available" />
          )}
        </div>
      </div>
    </Card>
  );
}

export default Announcement;
